import React from 'react';
import { useSearchParams } from 'react-router-dom';
import './search-results.scss';
import Breadcrumb from '../../shared/breadcrumb/breadcrumb.js';
import { useStore } from 'hooks/useStore';

export function SearchResults() {
  const {
    state: {
      services: { medicalServices },
      schedule: { doctors },
    },
  } = useStore();
  const [searchParams] = useSearchParams();
  const keyword = (searchParams.get('keyword') || '').toLowerCase();
  const area = (searchParams.get('area') || '').toLowerCase();

  return (
    <main>
      <Breadcrumb
        links={[
          { to: '/', text: 'Главная' },
          { to: '/search-results', text: 'Результаты поиска' },
        ]}
      />
      {/* /breadcrumb */}

      <div className="container margin_60">
        <div className="main_title">
          <h1>Результаты поиска</h1>
        </div>
        <div>
          {(area === 'all' || area === 'service') &&
            medicalServices
              .filter((p) => p.name.toLowerCase().indexOf(keyword) >= 0)
              .map((product) => (
                <div className="card add_bottom_45" key={product.id}>
                  <div className="card-body">
                    <a href={`/services/medical-services/${product.id}`}>
                      {product.name}
                    </a>
                  </div>
                </div>
              ))}
          {(area === 'all' || area === 'doctor') && (
            <div className="card add_bottom_45">
              <div className="card-body">
                <h2>График</h2>
                <div className="table-responsive">
                  <table className="table table-hover add_bottom_45">
                    <thead>
                      <tr>
                        <th>Ф. И. О.</th>
                        <th>Занимаемая должность</th>
                        <th>Начало приёма</th>
                        <th>Обед</th>
                        <th>Окончание приёма</th>
                      </tr>
                    </thead>
                    <tbody>
                      {doctors
                        .filter(
                          (d) =>
                            d.name.toLowerCase().indexOf(keyword) >= 0 ||
                            d.schedules.some(
                              (s) =>
                                s.groupKey.toLowerCase().indexOf(keyword) >= 0
                            )
                        )
                        .map((doctor) =>
                          doctor.schedules.map((schedule, index) => (
                            <tr key={schedule.groupKey}>
                              <td>{index === 0 ? doctor.name : ''}</td>
                              <td>{schedule.groupKey}</td>
                              <td>{schedule.start}</td>
                              <td>{schedule.dinner}</td>
                              <td>{schedule.end}</td>
                            </tr>
                          ))
                        )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </main>
  );
}

export default SearchResults;
